import type { MigrationStrategies } from "./_types/migration-strategies";

export const INVESTIGATION_CATALOGUE_ITEM_MIGRATION_STRATEGIES: MigrationStrategies =
  {
    1: (oldDoc) => oldDoc,
    2: (_) => null,
    3: (oldDoc) => oldDoc,
    4: (oldDoc) => oldDoc,
  };
